<forge-app-bar-profile-button #omniProfile [attr.avatar-text]="avatarDisplayName" [attr.email]="username"
                              [attr.full-name]="fullName" [attr.avatar-image-url]="photoUrl"
                              [attr.profile-button]="!isVendorUser" [profileCardBuilder]="cardBuilder"
                              (forge-profile-card-profile)="gotoProfile()" (forge-profile-card-sign-out)="logout()">
    <forge-badge *ngIf="notifications > 0">
        {{notifications}}
    </forge-badge>
</forge-app-bar-profile-button>